import { uuidv4 } from '@ubeya/shared/utils/uuid';
import moment from 'moment';

export const generatePositionWageValues = ({ wage, wages = [], externalWage = false, externalWageKey }) => {
  if (wages.length > 0) {
    const positionWages = wages.sort((a, b) => (moment(a.effectiveDate).isAfter(moment(b.effectiveDate)) ? -1 : 1));
    const matchingWage =
      positionWages.find(({ effectiveDate }) => moment(effectiveDate).isSameOrBefore(moment())) || null;

    /* if no matching wage to current time, generate empty wage  */
    return (
      matchingWage || {
        wage: { flatHours: 0, flatWage: 0, hourlyWage: 0, id: uuidv4() },
        [externalWageKey]: { flatHours: 0, flatWage: 0, hourlyWage: 0, id: uuidv4() }
      }
    );
  }

  return { [externalWageKey]: externalWage, wage };
};
